import { defineMessages, IntlShape } from "react-intl";

import PinLegendDataLevel from "@mapmycustomers/shared/enum/pinLegends/PinLegendDataLevel";

const messages = defineMessages<PinLegendDataLevel>({
  [PinLegendDataLevel.ORGANIZATION]: {
    id: "pinLegendDataLevel.org",
    defaultMessage: "Org Data",
  },
  [PinLegendDataLevel.USER]: {
    id: "pinLegendDataLevel.user",
    defaultMessage: "User Data",
  },
});

const getPinLegendDataLevelDisplayName = (intl: IntlShape, dataLevel: PinLegendDataLevel) =>
  intl.formatMessage(messages[dataLevel]);

export default getPinLegendDataLevelDisplayName;
